import React from "react";
import DatamapsIndia from "react-datamaps-india";
import { axInst } from "../../../Components/Login/Service";
import WaterMark from "../../../Components/WaterMark/WaterMark";
import { Loader } from "rsuite";
import { useQuery } from "@tanstack/react-query";
import { useSelector } from "react-redux";

const fetchStateWiseData = async (body) => {
  try {
    const res = await axInst.post("/stocks/state-wise-stocks", body);
    // console.log(res);
    return res.data.state_wise_stocks;
  } catch (error) {
    console.error(error);
  }
};

const stateNameMapping = {
  "Andaman & Nicobar": "Andaman & Nicobar Island",
  Chattisgarh: "Chhattisgarh",
  Orissa: "Odisha",
  Uttrakhand: "Uttarakhand",
};

const transformStateNames = (data) => {
  const transformedData = {};
  for (const [key, value] of Object.entries(data)) {
    const newKey = stateNameMapping[key] || key;
    transformedData[newKey] = value;
  }
  return transformedData;
};

const IndiaMap = () => {
  const { data, submitted } = useSelector((e) => e.filtersStock);

  const {
    data: stateWise,
    isFetching,
    isError,
  } = useQuery({
    queryKey: ["state", submitted],
    queryFn: () => fetchStateWiseData(data),
    refetchInterval: 300000,
    refetchIntervalInBackground: true,
  });

  const transformedStateWise = stateWise ? transformStateNames(stateWise) : {};

  return (
    <div className="p-2">
      <h2 className="text-base font-semibold text-[#474747]">
        State Wise Stock
      </h2>
      {isFetching && (
        <div className="grid items-center justify-center w-full h-full">
          <Loader />
        </div>
      )}
      {isError && (
        <div className="grid items-center justify-center w-full h-full">
          <p>Error Occurred</p>
        </div>
      )}
      <div className="m-[56px];">
        <WaterMark />
      </div>
      <div className="map w-full ">
        <DatamapsIndia
          regionData={transformedStateWise}
          hoverComponent={({ value }) => {
            return (
              <div
                style={{
                  backgroundColor: "white",
                  padding: "5px",
                  borderRadius: "5px",
                  position: "absolute",
                  pointerEvents: "none",
                  boxShadow: "0px 0px 14px rgba(0, 0, 0, 0.3)",
                }}
              >
                <b className="whitespace-nowrap">{value.name}</b>: {value.value}
              </div>
            );
          }}
          mapLayout={{
            title: "",
            startColor: "#a2edf2",
            endColor: "#64d1d9",
            hoverTitle: ({ value }) => `${value.name}: ${value.value}`,
            noDataColor: "#f5f5f5",
            borderColor: "#8D8D8D",
            hoverColor: "#97d1e6",
          }}
          style={{ width: "100%", height: "100%" }}
        />
      </div>
    </div>
  );
};

export default IndiaMap;
